import { render } from "./Contact.vue?vue&type=template&id=81b2de1a&scoped=true&bindings={}"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=81b2de1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-81b2de1a"

export default script